import history from 'src/history'
import { Button } from 'src/Components'
import { defineMessages, useIntl } from 'react-intl'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import { ListingDetailsListing } from 'src/types/listings'
import { ListingActionBar } from 'src/Components/ListingDetails/ListingActionBar'

import styles from './DesktopListingDetailsImage.module.scss'

export const MSG = defineMessages({
  alt: {
    id: 'HomeSearch.listingDetails.imageAlt',
    defaultMessage: 'Listing photo',
  },
})

export interface DesktopListingDetailsImageProps {
  listing: ListingDetailsListing
}

export const DesktopListingDetailsImage = ({
  listing,
}: DesktopListingDetailsImageProps) => {
  const intl = useIntl()

  return (
    <div className={styles.imageContainer}>
      <ListingActionBar showTourButton={true} listing={listing} opacity={0} />
      <Button
        onClick={() =>
          history.push(OVERLAY_HELPERS.listingDetailsPhotos.buildPath())
        }
      >
        <img
          src={listing.imageCoverUrl}
          className={styles.heroImage}
          alt={intl.formatMessage(MSG.alt)}
        />
      </Button>
    </div>
  )
}
